import { useMemo } from 'react';
import {
  IAnyPanel,
  ITypeRequest,
} from '../../../../../../theme/ui/Dashboard/Dashboard.model';
import { useTranslation } from 'react-i18next';
import useIsAdmin from '../../../../WorkspaceAdmin/useIsAdmin';

function getUrlForPanel(
  workspaceId: string | undefined,
  groupId: string | undefined,
  panelType: string,
  isAdmin: boolean
) {
  if (panelType === 'COMMANDER_OFFLINE') {
    if (workspaceId) {
      if (groupId) {
        return `/markets/${workspaceId}/view-locations/${groupId}/dashboard/commander-offline`;
      } else {
        return `/markets/${workspaceId}/view-locations/dashboard/commander-offline`;
      }
    } else {
      if (isAdmin) {
        return `/markets/dashboard/commander-offline`;
      }
      if (groupId) {
        return `/manager/view-locations/${groupId}/dashboard/commander-offline`;
      } else {
        return `/manager/view-locations/dashboard/commander-offline`;
      }
    }
  }
}

function useListPanels(
  typeRequest: ITypeRequest,
  workspaceId?: string,
  groupId?: string
): IAnyPanel[] {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();
  const panels = useMemo(
    () =>
      [
        {
          type: 'STORES',
          typeRequest,
          workspaceId,
          groupId,
          id: 'stores',
          title: t('dashboard.stores.title'),
        },
        {
          type: 'COMMANDER_OFFLINE',
          typeRequest,
          workspaceId,
          groupId,
          id: 'commander-offline',
          href: getUrlForPanel(
            workspaceId,
            groupId,
            'COMMANDER_OFFLINE',
            isAdmin
          ),
          title: t('dashboard.commander_offline.title'),
        },
        // {
        //   type: 'LABEL_VALUE',
        //   id: 'panel-divider-1',
        //   title: 'Widget not connected',
        //   content: '------------',
        // },
        // {
        //   type: 'LOW_TEMP',
        //   typeRequest,
        //   workspaceId,
        //   groupId,
        //   id: 'low-temp',
        //   title: t('dashboard.low_temp.title'),
        // },
        // {
        //   type: 'GATEWAY_ERROR',
        //   typeRequest,
        //   workspaceId,
        //   groupId,
        //   id: 'gateway-error',
        //   title: t('dashboard.gateway_error.title'),
        // },
        // {
        //   type: 'FLEXESERVE_DEVICE_ERROR',
        //   typeRequest,
        //   workspaceId,
        //   groupId,
        //   id: 'flexeserve-device-error',
        //   title: t('dashboard.flexeserve_device_error.title'),
        // },
        // {
        //   type: 'SMART_SWITCH_DEVICE_ERROR',
        //   typeRequest,
        //   workspaceId,
        //   groupId,
        //   id: 'smart-switch-device-error',
        //   title: t('dashboard.smart_switch_device_error.title'),
        // },
        // {
        //   type: 'ENERGY_CONSUMPTION_FLEXESERVE',
        //   typeRequest,
        //   workspaceId,
        //   groupId,
        //   id: 'energy-consumption-flexeserve',
        //   title: t('dashboard.energy_consumption_flexeserve.title'),
        //   subtitle: t('dashboard.energy_consumption_flexeserve.subtitle'),
        // },
        // {
        //   type: 'LABEL_VALUE',
        //   id: 'example-panels',
        //   title: 'Example Panels',
        //   content: '------------',
        // },
        // {
        //   type: 'LABEL_VALUE',
        //   id: 'group-temperature',
        //   title: 'Group Temperature',
        //   content: '21.0 °C',
        // },
        // {
        //   type: 'LABEL_VALUE',
        //   id: 'active-devices',
        //   title: 'Active devices',
        //   content: '8',
        // },
        // {
        //   type: 'LABEL_VALUE',
        //   id: 'energy-efficiency',
        //   title: 'Energy efficiency',
        //   content: '92%',
        // },
        // {
        //   type: 'TREND',
        //   id: 'uptime',
        //   title: 'Uptime',
        //   subtitle: 'Last 7 days',
        //   sparkLineProps: {
        //     data: [10, 12, 8, 15, 20, 18, 22],
        //   },
        // },
        // {
        //   type: 'TREND',
        //   id: 'downtime',
        //   title: 'Downtime',
        //   subtitle: 'Last 7 days',
        //   sparkLineProps: {
        //     data: [5, 8, 6, 10, 12, 9, 7],
        //   },
        // },
        // {
        //   type: 'PIE_CHART',
        //   id: 'device-status',
        //   title: 'Device Status',
        //   subtitle: `Extracted: ${moment().format('LLL')}`,
        //   series: [
        //     {
        //       startAngle: -90,
        //       endAngle: 90,
        //       data: [
        //         { label: 'Healthy', value: 100 },
        //         { label: 'Disconnected', value: 5 },
        //         { label: 'Error', value: 10 },
        //       ],
        //       innerRadius: '100%',
        //       outerRadius: '150%',
        //       cy: '100%',
        //     },
        //   ],
        // },
        // {
        //   type: 'PIE_CHART',
        //   id: 'alarms-pie',
        //   title: 'Alarms',
        //   subtitle: `Extracted: ${moment().format('LLL')}`,
        //   series: [
        //     {
        //       data: [
        //         { label: 'Type 1', value: 12, color: theme.palette.error.main },
        //         {
        //           label: 'Type 2',
        //           value: 8,
        //           color: theme.palette.warning.main,
        //         },
        //       ],
        //       innerRadius: '70%',
        //       outerRadius: '100%',
        //     },
        //   ],
        // },
        // {
        //   type: 'GAUGE',
        //   id: 'system-performance',
        //   title: 'System Performance',
        //   gaugeProps: {
        //     value: 75,
        //   },
        //   subtitle: 'Overall efficiency',
        // },
        // {
        //   type: 'BAR_CHART',
        //   id: 'open-issues',
        //   title: 'Open Issues',
        //   subtitle: 'Issues opened daily',
        //   dataset: [
        //     { weekDay: 'Monday', value: 100 },
        //     { weekDay: 'Tuesday', value: 80 },
        //     { weekDay: 'Wednesday', value: 60 },
        //     { weekDay: 'Thursday', value: 120 },
        //     { weekDay: 'Friday', value: 90 },
        //     { weekDay: 'Saturday', value: 30 },
        //     { weekDay: 'Sunday', value: 10 },
        //   ],
        //   dataKey: 'value',
        //   xAxisKey: 'weekDay',
        // },
        // {
        //   type: 'DATA_GRID',
        //   id: 'alarms-grid',
        //   title: 'Alarms',
        //   subtitle: 'Recent group alarms',
        //   columns: [
        //     { field: 'date', headerName: 'Data', width: 150 },
        //     { field: 'title', headerName: 'Title', width: 200 },
        //     { field: 'column3', headerName: 'Column3', width: 150 },
        //     { field: 'column4', headerName: 'Column4', width: 150 },
        //   ],
        //   rows: [
        //     {
        //       id: 1,
        //       date: '2026-01-27',
        //       title: 'Temperature Alert',
        //       column3: 'High',
        //       column4: 'Active',
        //     },
        //     {
        //       id: 2,
        //       date: '2026-01-26',
        //       title: 'Power Failure',
        //       column3: 'Critical',
        //       column4: 'Resolved',
        //     },
        //     {
        //       id: 3,
        //       date: '2026-01-25',
        //       title: 'System Overload',
        //       column3: 'Medium',
        //       column4: 'Active',
        //     },
        //   ],
        // },
      ] as IAnyPanel[],
    [groupId, isAdmin, t, typeRequest, workspaceId]
  );
  return panels;
}

export default useListPanels;
